function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React, { useContext } from "react";
import { useUIDSeed } from "react-uid";
import { Body, CallToAction, Heading } from "../../atoms";
import { ImageContext } from "../../../context";
import { ArrowRight } from "../../icons";
export var IconInfoListItem = function(param) {
    var icon = param.icon, title = param.title, description = param.description, className = param.className, callToActions = param.callToActions;
    var seed = useUIDSeed();
    var ImageComponent = useContext(ImageContext).ImageComponent;
    return /*#__PURE__*/ React.createElement("article", {
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mb-5 flex justify-start items-center"
    }, !!icon && /*#__PURE__*/ React.createElement(ImageComponent, _extends({}, icon, {
        className: "shrink-0 mr-3 w-[3.125rem] h-auto"
    })), /*#__PURE__*/ React.createElement(Heading, {
        as: "h4",
        variant: "h4"
    }, title)), /*#__PURE__*/ React.createElement("div", {
        className: "prose md:prose-md"
    }, /*#__PURE__*/ React.createElement(Body, null, description)), !!(callToActions === null || callToActions === void 0 ? void 0 : callToActions.length) && /*#__PURE__*/ React.createElement("div", {
        className: "mt-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap flex-col items-start justify-start -mx-6 -my-2"
    }, callToActions.map(function(callToAction) {
        return /*#__PURE__*/ React.createElement(CallToAction, _extends({
            key: seed(callToAction),
            icon: /*#__PURE__*/ React.createElement(ArrowRight, null),
            className: "mx-6 my-2"
        }, callToAction));
    }))));
};

//# sourceMappingURL=IconInfoListItem.js.map